import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", null, "Object", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Ruimte", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Status", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Contactpersoon", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Telefoonnummer contactpersoon", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "E-mailadres contactpersoon", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Onderwerp", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Omschrijving", -1)
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Afbeeldingen", -1)

import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import { Issue } from '@/types/Issue'
import Banner from '@/components/Banner.vue'
import Filelist from '@/components/Filelist.vue'
import Comments from '@/components/service/Comments.vue'
import NewComment from '@/components/service/NewComment.vue'
import DisagreeMessage from '@/components/service/DisagreeMessage.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'IssueShow',
  setup(__props) {

const route = useRoute()
const issue = ref<Issue|null>(null)

onMounted(() => {
  getIssue()
})

function getIssue () : void {
  axios.get(process.env.VUE_APP_API_URL + '/issues/' + route.params.issueId).then((r) => {
    issue.value = r.data
    if (issue.value && issue.value.comments) {
      issue.value.comments = issue.value.comments.reverse()
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,16] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: `Servicemelding #${_unref(route).params.issueId}`,
            bordered: false,
            loading: !issue.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1,
                      _createElementVNode("p", null, _toDisplayString(issue.value.building.address) + " " + _toDisplayString(issue.value.building.zipcode) + " " + _toDisplayString(issue.value.building.city), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _createElementVNode("p", null, _toDisplayString(issue.value.room.name), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      _createElementVNode("p", null, _toDisplayString(issue.value.status_label), 1),
                      (issue.value.status === 2)
                        ? (_openBlock(), _createBlock(DisagreeMessage, {
                            key: 0,
                            "model-id": _unref(route).params.issueId,
                            onUserDisagreed: getIssue
                          }, null, 8, ["model-id"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_divider),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _createElementVNode("p", null, _toDisplayString(issue.value.tenant_name), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      _createElementVNode("p", null, _toDisplayString(issue.value.tenant_phone), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _createElementVNode("p", null, _toDisplayString(issue.value.tenant_email), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_divider),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createElementVNode("p", null, _toDisplayString(issue.value.title), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 24
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8,
                      _createElementVNode("div", {
                        innerHTML: issue.value.description
                      }, null, 8, _hoisted_9)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { gutter: [32,32] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    span: 24,
                    xl: 24
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10,
                      (issue.value.files.length)
                        ? (_openBlock(), _createBlock(Filelist, {
                            key: 0,
                            "media-items": issue.value.files
                          }, null, 8, ["media-items"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title", "loading"]),
          _createVNode(_component_a_card, {
            title: "Berichten",
            style: {"margin-top":"16px"},
            bordered: false,
            loading: !issue.value
          }, {
            default: _withCtx(() => [
              _createVNode(NewComment, {
                "model-type": "issue",
                "model-id": _unref(route).params.issueId,
                onCommentCreated: getIssue
              }, null, 8, ["model-id"]),
              (issue.value && issue.value.comments.length)
                ? (_openBlock(), _createBlock(Comments, {
                    key: 0,
                    comments: issue.value.comments
                  }, null, 8, ["comments"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})